module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAOklEQVQ4y2NgGBTgi4b5fxgGAQa1ZDAGAWQ5dDyIDPiPBpANwAcQgQDVQDKmmgEUe2EYRCPFBgxtAABEBoBUip+EkwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/NO.png
// module id = 1230
// module chunks = 0